
import { Activation } from '@/store/models/jwt';
import { JwtStore } from '@/store/modules';
import { Component, Vue } from 'vue-property-decorator';

import QvInput from '@/components/FormComponents/QvInput.vue';
import { ValidationObserver } from 'vee-validate';

@Component({
  components: {
    ValidationObserver,
    QvInput
  },
  meta: {
    title: 'Activate Account'
  }
})
export default class UserActivation extends Vue {
  payload = {} as Activation;
  title = '';
  message = '';
  caption = '';
  email = '';
  login = false;
  resend = false;

  created() {
    this.payload.uid = this.$route.params.uid;
    this.payload.token = this.$route.params.token;
    JwtStore.userActivation(this.payload)
      .then(response => {
        this.title = 'Activation Successful';
        this.message = 'Your account was activated successfully.';
        this.caption = 'Please login to continue!';
        this.login = true;
        if (response.message) {
          this.$q.notify({
            type: 'positive',
            message: `${response.message}`,
            timeout: 5000
          });
        }
      })
      .catch(() => {
        this.title = 'Activation Error';
        this.message = 'There was an error activating your account.';
        this.caption = 'Please try resending activation mail!';
        this.resend = true;
      });
  }

  onSubmit() {
    if (this.email != '') {
      JwtStore.resendActivation({ email: this.email.toLowerCase() }).then(
        response => {
          if (response.message) {
            this.$q.notify({
              type: 'positive',
              message: `${response.message}`,
              timeout: 5000
            });
          }
        }
      );
    }
  }
}
